<template>
  <div
    ref="dropdownContainer"
    v-click-outside="() => (showDropdown = false)"
    class="dropdown-container"
    tabindex="0"
  >
    <div
      class="dropdown-reveal"
      :class="{ 'no-click': disabled, greyed: !selected }"
      @click.self="toggleDropdown"
    >
      <div class="selected-item">
        <slot v-if="selected" name="selectedItem" :value="selected">{{ selected }}</slot>
        <slot v-else>{{ menuLabel }}</slot>
      </div>
      <div v-if="!disabled" class="chev-container">
        <font-awesome-icon
          v-if="!selected || !showCloseOnSelected"
          :icon="showDropdown ? 'caret-up' : 'caret-down'"
          @click="toggleDropdown"
        />
        <font-awesome-icon
          v-else
          icon="times-circle"
          @click="
            selected = null;
            $emit('clear-item');
          "
        />
      </div>
    </div>
    <div v-show="showDropdown" class="dropdown-menu">
      <div class="dropdown-searchbox">
        <input
          ref="search"
          type="text"
          class="input-field"
          @input="filterDropdown($event)"
          @keyup="nextItem($event)"
          @keyup.enter="onItemSelected(dropdownList[currentItem], currentItem)"
        />
        <font-awesome-icon icon="search" />
      </div>
      <ul v-if="dropdownList.length">
        <li
          v-for="(item, index) in dropdownList"
          :key="index"
          :class="{ 'active-item': currentItem == index }"
          @click="onItemSelected(item, index)"
          @mouseover="currentItem = index"
        >
          <span v-if="item && item.icon"><font-awesome-icon :icon="item.icon"/></span>
          <slot name="dropdownItem" :value="item">{{ item }}</slot>
        </li>
      </ul>
      <div v-else class="no-result">{{ $t('dropdown.noResult') }}</div>
    </div>
    <!--<span>{{ menuLabel }}</span> -->
  </div>
</template>

<script>
import vClickOutside from 'v-click-outside';

export default {
  name: 'DropdownSelect',
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    menuItems: {
      type: Array,
      required: true
    },
    selectedItem: {
      type: [String, Number, Object],
      default: ''
    },
    menuLabel: {
      type: String,
      default: ''
    },
    menuObjects: {
      type: Array,
      default: null
    },
    filterOn: {
      type: Array,
      default: () => {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showCloseOnSelected: {
      type: Boolean,
      default: true
    },
    dropdownOpenByDefault: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDropdown: false,
      selected: null,
      dropdownList: [],
      dropdownObjectList: [],
      currentItem: 0
    };
  },
  watch: {
    menuItems: {
      immediate: true,
      handler() {
        this.dropdownList = this.menuItems.slice();
      }
    },
    menuObjects: {
      immediate: true,
      handler(val) {
        if (val) this.dropdownObjectList = this.menuObjects.slice();
      }
    },
    selectedItem: {
      immediate: true,
      handler() {
        this.selected = this.selectedItem;
      }
    },
    dropdownOpenByDefault: {
      immediate: true,
      handler() {
        if (this.dropdownOpenByDefault) {
          this.showDropdown = true;
        }
      }
    }
  },
  mounted() {
    if (this.disabled) {
      this.$refs.clickContainer;
    }
  },
  methods: {
    toggleDropdown() {
      if (this.$refs.dropdownContainer.getAttribute('disabled')) {
        return;
      }
      this.showDropdown = !this.showDropdown;
      if (this.showDropdown) {
        this.$nextTick(() => {
          this.$refs.search.focus();
        });
      }
    },
    filterDropdown(event) {
      const filterKey = event.target.value.trim().toLowerCase();
      let filteredList = [];
      let filteredObjectList = [];
      if (filterKey.length >= 1) {
        filteredList = this.menuItems.filter(item => {
          let findIndexList = [];
          if (this.filterOn.length) {
            for (let filterProp of this.filterOn) {
              findIndexList.push(
                item[filterProp]
                  .toString()
                  .toLowerCase()
                  .search(filterKey)
              );
            }
            return findIndexList.some(item => item !== -1);
          }
          return (
            item
              .toString()
              .toLowerCase()
              .search(filterKey) !== -1
          );
        });
        this.dropdownList = filteredList;
        this.currentItem = 0;
        if (this.menuObjects) {
          filteredObjectList = this.menuObjects.filter(item => {
            let findIndexList = [];
            if (this.filterOn.length) {
              for (let filterProp of this.filterOn) {
                findIndexList.push(
                  item[filterProp]
                    .toString()
                    .toLowerCase()
                    .search(filterKey)
                );
              }
              return findIndexList.some(item => item !== -1);
            }
            return (
              item
                .toString()
                .toLowerCase()
                .search(filterKey) !== -1
            );
          });

          this.dropdownObjectList = filteredObjectList;
        }
      } else {
        this.dropdownList = this.menuItems;
      }
    },
    nextItem(event) {
      if (event.key === 'ArrowUp' && this.currentItem > 0) {
        this.currentItem--;
      } else if (event.key === 'ArrowDown' && this.currentItem < this.dropdownList.length - 1) {
        this.currentItem++;
      }
    },
    onItemSelected(dropdownItem, index) {
      if (!this.dropdownList.length) return;

      if (
        (this.dropdownObjectList && this.dropdownObjectList.length > 0) ||
        (this.dropdownList && this.dropdownList.length > 0)
      ) {
        this.dropdownObjectList && this.dropdownObjectList.length > 0
          ? this.$emit('select-item', this.dropdownObjectList[index])
          : this.$emit('select-item', this.dropdownList[index]);
      } else {
        this.menuObjects && this.menuObjects.length > 0
          ? this.$emit('select-item', this.menuObjects[index])
          : this.$emit('select-item', dropdownItem);
      }
      this.selected = dropdownItem;
      this.toggleDropdown();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/colors.scss';

.dropdown-container {
  position: relative;
  display: flex;
  flex: 1;

  &.blue {
    border: 1px solid $blue;
  }

  .dropdown-reveal {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;

    &.no-click {
      pointer-events: none;
    }
    &.greyed {
      font-weight: normal;
      div:first-of-type {
        color: $light-grey-1;
      }
    }
  }

  &.generate-report-dropdown {
    border: 1px solid $light-grey-1;
    background-color: $white;
  }

  &.no-box {
    .dropdown-reveal {
      height: auto;
      padding: 0;
      border: 0;
    }
  }

  .selected-item {
    display: flex;
    align-items: center;
  }

  .chev-container {
    width: 15px;
    text-align: center;
    padding: 2px 0;
    margin-right: 2%;
  }

  .dropdown-menu {
    width: 100%;
    max-height: 450px;
    position: absolute;
    top: 100%;
    background-color: $white;
    opacity: 1;
    z-index: 50;
    overflow-y: auto;
    border: 0.5px solid $mid-grey-1;

    &.constant li {
      border: 3px solid red;
    }

    > ul {
      list-style: none;
      margin: 0;
      padding: 0;
      > li {
        display: flex;
        justify-content: center;
        padding: 15px 15px;

        border-top: 1px solid $row-border;
        &:hover {
          cursor: pointer;
        }

        > span {
          margin-right: 15px;
        }
      }
    }
    .dropdown-searchbox {
      display: flex;
      border: 1px solid $input-border;
      align-items: center;
      .input-field {
        width: 100%;
        height: 100%;
        border: 0;
        font-size: 0.9em;
        padding: 8px 0;
        &:focus {
          outline: none;
        }
      }
    }

    .no-result {
      display: flex;
      background-color: $light-grey-2;
      justify-content: center;
      padding: 8px 0;
      color: $mid-grey-1;
    }
  }

  &.bordered {
    display: flex;
    border: 1px solid $blue;
    height: 40px;
    background-color: $white;

    .dropdown-reveal {
      align-items: center;
      border-bottom: none;
      .chev-container {
        text-align: right;
      }
    }

    &.small {
      font-size: 0.7rem;

      ul li {
        padding: 8px 8px;
      }
    }
  }
  &.blue {
    .dropdown-menu {
      ul > li {
        background-color: $light-blue;
        &:hover,
        &.active-item {
          background-color: $dark-blue;
          color: $mid-blue;
        }
      }
    }
    &.small {
      font-size: 0.7em;
    }
  }
  &.constant .dropdown-menu li {
    width: 150px;
  }
}
</style>
